var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.89 1.994 4.367 8.552a1 1 0 0 1-.89 1.454H1.634a1 1 0 0 1-.891-1.454L5.11 1.994a1 1 0 0 1 1.78 0M6 4a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3A.5.5 0 0 1 6 4m0 5a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1A.5.5 0 0 1 6 9",
    clipRule: "evenodd"
  })));
});
const SvgAlertFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljg5MDc4IDEuOTk0NDRMMTEuMjU3MyAxMC41NDU2QzExLjU5NzEgMTEuMjEwOSAxMS4xMTM4IDEyLjAwMDMgMTAuMzY2NyAxMi4wMDAzSDEuNjMzNjRDMC44ODY1NTUgMTIuMDAwMyAwLjQwMzI4IDExLjIxMDkgMC43NDMwMzkgMTAuNTQ1Nkw1LjEwOTU3IDEuOTk0NDRDNS40ODA3OCAxLjI2NzQ4IDYuNTE5NTYgMS4yNjc0OCA2Ljg5MDc4IDEuOTk0NDRaTTYuMDAwMTcgNC4wMDAzNEM2LjI3NjMyIDQuMDAwMzQgNi41MDAxNyA0LjIyNDIgNi41MDAxNyA0LjUwMDM0VjcuNTAwMzRDNi41MDAxNyA3Ljc3NjQ4IDYuMjc2MzIgOC4wMDAzNCA2LjAwMDE3IDguMDAwMzRDNS43MjQwMyA4LjAwMDM0IDUuNTAwMTcgNy43NzY0OCA1LjUwMDE3IDcuNTAwMzRWNC41MDAzNEM1LjUwMDE3IDQuMjI0MiA1LjcyNDAzIDQuMDAwMzQgNi4wMDAxNyA0LjAwMDM0Wk02LjAwMDE3IDkuMDAwMzRDNi4yNzYzMiA5LjAwMDM0IDYuNTAwMTcgOS4yMjQyIDYuNTAwMTcgOS41MDAzNFYxMC41MDAzQzYuNTAwMTcgMTAuNzc2NSA2LjI3NjMyIDExLjAwMDMgNi4wMDAxNyAxMS4wMDAzQzUuNzI0MDMgMTEuMDAwMyA1LjUwMDE3IDEwLjc3NjUgNS41MDAxNyAxMC41MDAzVjkuNTAwMzRDNS41MDAxNyA5LjIyNDIgNS43MjQwMyA5LjAwMDM0IDYuMDAwMTcgOS4wMDAzNFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";